'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'hill-avalanche';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e507';
var svgPathData = 'M191.7 48c-24.3 0-44.5 18.2-47.5 41.8L448 394.2c17.9 17.9 46.6 18.9 65.6 2.2l4.2-3.7c19.4-17 19.6-47.2 .5-64.5-14.3-12.9-35.4-14.8-51.7-4.5l-3 1.9c-7.5 4.7-17.3 2.4-22-5.1s-2.4-17.4 5.1-22.1l3-1.9c28.4-17.8 65.2-14.6 90.1 7.9 33.3 30.2 32.9 82.7-.8 112.3l-4.2 3.7c-31.7 27.8-79.5 26.2-109.3-3.6L116.5 107.3c-3.3-3.3-4.9-7.8-4.7-12.2 .4-43.8 36-79.2 79.9-79.2 16.9 0 32.6 5.3 45.5 14.3 14.6-9 31.9-14.3 50.3-14.3 53 0 95.8 43 95.8 96 0 4.2-.3 8.3-.8 12.4 29.1 16.5 48.7 47.7 48.7 83.6 0 21.6-7.1 41.6-19.2 57.6-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c8-10.7 12.8-24 12.8-38.4 0-27.1-16.8-50.3-40.6-59.6-7.6-3-11.8-11.3-9.6-19.2 1.5-5.4 2.3-11.2 2.3-17.2 0-35.4-28.6-64-63.8-64-15.5 0-29.7 5.5-40.7 14.7-6.3 5.3-15.6 4.9-21.5-.9-8.7-8.6-20.5-13.8-33.6-13.8zM415.3 64a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zm31.9 96a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zM54.6 96.1L415.3 457.4c20.1 20.2 5.8 54.6-22.6 54.6L64 512c-35.3 0-64-28.7-64-64L0 118.7C0 90.2 34.5 75.9 54.6 96.1zM32 448c0 17.7 14.3 32 32 32L392.6 480 32 118.7 32 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHillAvalanche = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;